// extracted by mini-css-extract-plugin
export default {"close":"DegreeCertRows_close__5M9ui","outerContainer":"DegreeCertRows_outerContainer__lvxBl","container":"DegreeCertRows_container__wy4wC"};